import styled from 'styled-components';
import { Typ35, Typ51 } from 'dc/Typ';

type WrapperProps = {
  color?: string;
  onClick?: () => void;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: ${props => props.color || 'transparent'};
  padding: 48px 16px;
  border-radius: 16px;
  width: 100%;
  max-width: 288px;
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`;

type NewWrapperProps = {
  color?: string;
};

export const NewWrapper = styled.div<NewWrapperProps>`
  position: absolute;
  top: 0;
  right: 16px;
  padding: 5px 4px 3px;
  border-radius: 0 0 4px 4px;
  background: ${props => props.color || 'transparent'};
`;

export const NewText = styled.span`
  font-family: Hind, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.0333em;
  color: #ffffff;
`;

export const Overline = styled.span`
  font-family: Hind, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #263238;
  margin-bottom: 16px;
`;

export const Title = styled(Typ51)``;

export const Text = styled(Typ35)`
  margin-top: 16px;
  line-height: 120%;
  span:first-of-type {
    padding: 0;
  }
`;

export const More = styled.span`
  margin-top: 16px;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  text-align: right;
  letter-spacing: 0.0094em;
  text-decoration-line: underline;
  color: #263238;
  align-self: flex-end;
`;

export const Link = styled.a`
  margin-top: 16px;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  text-align: right;
  letter-spacing: 0.0094em;
  text-decoration-line: underline;
  color: #263238;
  align-self: flex-end;
`;
